module.exports = __webpack_public_path__ + "static/AM_web_900x452-0cf9fce5364b50e2c112a7e3891ee184.png";